import React from 'react';
// import {Link} from 'react-router-dom'
import UnAuthorizedPage from './UnAuthorizedPage';
import ResetPasswordContainer from '../containers/ResetPasswordContainer';
import UnAuthorizedHeader from '../components/UnAuthorizedHeader'


const Login = () => (
    <UnAuthorizedPage>
        <UnAuthorizedHeader header="Reset Password" text="Enter your new password" />
        <ResetPasswordContainer />
    </UnAuthorizedPage>
);

export default Login;


// WEBPACK FOOTER //
// ./src/pages/ResetPasswordPage.js